// @ts-nocheck
import LocalizedLink from '@/components/ui/LocalizedLink';
import { styled } from '@mui/material/styles';
import { Components as MarkdownComponents } from 'react-markdown';
import { SpecialComponents } from 'react-markdown/lib/ast-to-react';
import { Typography } from '@mui/material';

const Table = styled('table')`
  margin-bottom: 32px;
  margin-top: 32px;
  width: 100%;

  td,
  th {
    color: ${({ theme }) => theme.palette.text.primary};
    padding: 8px;
  }
`;
const TableBox = styled('div')`
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
`;

const ThemedComponent = styled('div')`
  color: ${({ theme }) => theme.palette.text.primary};
  margin-bottom: 16px;
  margin-top: 16px;

  li {
    margin-bottom: 8px;
  }
`;

const Pre = styled('pre')`
  color: ${({ theme }) => theme.palette.text.primary};
  margin-bottom: 16px;
  margin-top: 16px;
  max-width: 100%;
  overflow-x: auto;
`;

const AStyle = styled(LocalizedLink)`
  word-break: break-all;
  color: ${({ theme }) => theme.palette.success.main};
  target: '_blank';
`;

const Title = (props: any) => {
  return <Typography {...props} />;
};

export const markdownComponents: Partial<
  MarkdownComponents & SpecialComponents
> = {
  h1: (props) =>
    Title({
      ...props,
      variant: 'h1',
      fontSize: ['2em', '2em', '2em', '2em'],
      fontWeight: 'bold',
      mt: [4, 3, 2, 2],
      mb: [3, 2, 2, 1.5],
    }),
  h2: (props) =>
    Title({
      ...props,
      variant: 'h2',
      fontSize: ['1.5em', '1.5em', '1.5em', '1.5em'],
      fontWeight: 'bold',
      mt: [4, 3, 2, 2],
      mb: [3, 2, 2, 1.5],
    }),
  h3: (props) =>
    Title({
      ...props,
      variant: 'h3',
      fontSize: ['1.17em', '1.17em', '1.17em', '1.17em'],
      fontWeight: 'bold',
      mt: [4, 3, 2, 2],
      mb: [3, 2, 2, 1.5],
    }),
  h4: (props) =>
    Title({
      ...props,
      variant: 'h4',
      fontSize: '1em',
      fontWeight: 'bold',
      md: '20px',
    }),
  h5: (props) =>
    Title({
      ...props,
      variant: 'h5',
      fontSize: '0.83em',
      fontWeight: 'bold',
      md: '20px',
    }),
  h6: (props) =>
    Title({
      ...props,
      variant: 'h6',
      fontSize: '0.67em',
      fontWeight: 'bold',
      md: '20px',
    }),
  p: (props) => {
    return <Typography {...props} />;
  },
  table: ({ ...props }) => {
    return (
      <TableBox>
        <Table>{props.children} </Table>
      </TableBox>
    );
  },
  ol: (props: any) => {
    return (
      <ThemedComponent style={{ marginLeft: '32px' }} as="ol" {...props} />
    );
  },
  ul: (props: any) => {
    return (
      <ThemedComponent as="ul" style={{ marginLeft: '32px' }} {...props} />
    );
  },
  // @ts-ignore
  pre: Pre,
  // @ts-ignore
  a: (props) => <AStyle {...props} />,
};

export default markdownComponents;
